/*******************************************/
/** UTILITY FUNCTIONS FOR COOKIE HANDLING **/
/*******************************************/

/**
 * Creates a 'javascript' cookie with supplied name & value
 * expire date will be determined by the amount of days supplied
 */
export const createCookie = (name, value, days) => {
  if (typeof window !== 'undefined') {
    let expires = ''
    if (days) {
      const date = new Date()
      date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000)
      expires = '; expires=' + date.toUTCString()
    }

    document.cookie = `${name}=${value}${expires}; Path=/; Secure; SameSite=Strict`
  }
}

/**
 * Checks if cookie with supplied name is available
 * if available returns the cookie value else returns false
 */
export const readCookie = (name) => {
  if (typeof window !== 'undefined') {
    const nameEQ = name + '='
    const ca = document.cookie.split(';')
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i]
      while (c.charAt(0) === ' ') {
        c = c.substring(1, c.length)
      }

      if (c.indexOf(nameEQ) === 0) {
        return c.substring(nameEQ.length, c.length)
      }
    }
    return null
  } else {
    return null
  }
}

export default {
  readCookie,
  createCookie
}
